export const getDialogFormDisplaySettingsKeyByUserId = (userId: string) =>
  `lh:DialogFormDisplaySettings:Settings:persist:${userId}`;
export const getPatientsListViewKeyByUserId = (userId: string) => `lh:patients_list_view:persist:${userId}`;
export const getWaitingRoomFacilityKeyByUserId = (userId: string) => `lh:waiting-room:facility:persist:${userId}`;
